export default __webpack_public_path__ + "static/media/OSH_Preview_Video.d031c820.mp4";